export enum ProductType {
  FileFeeds = "filefeeds",
  Workflows = "workflows",
  Workspaces = "workspaces",
}
